import React from 'react';
export function OfferingSummary() {
  return <div className="min-h-screen bg-[#f4f7f9] font-sans text-slate-800" data-id="element-486">
      {/* Header Section */}
      <header className="bg-[#0f2546] text-white pt-5 pb-4 px-6 md:px-10" data-id="element-487">
        <div className="max-w-7xl mx-auto" data-id="element-488">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4 gap-4" data-id="element-489">
            <div data-id="element-490">
              <div className="flex items-center space-x-2 mb-0.5" data-id="element-491">
                <span className="text-2xl font-bold tracking-tight" data-id="element-492">
                  Swedenmark <span className="text-blue-400" data-id="element-493">AI</span>
                </span>
              </div>
              <p className="text-slate-400 text-[10px] tracking-[0.2em] uppercase font-semibold" data-id="element-494">
                AI Automation & Growth Consulting
              </p>
            </div>
            <div className="text-xs text-slate-300 space-y-0.5" data-id="element-495">
              <p data-id="element-496">
                <strong className="text-white" data-id="element-497">Target:</strong> Mid-market ·
                $10M–$100M revenue
              </p>
              <p data-id="element-498">
                <strong className="text-white" data-id="element-499">Model:</strong> Retainer +
                Performance-Based
              </p>
              <p data-id="element-500">
                <strong className="text-white" data-id="element-501">Location:</strong> Pompano Beach,
                FL · Nationwide
              </p>
            </div>
          </div>

          <p className="text-slate-300 text-xs leading-relaxed max-w-5xl" data-id="element-502">
            We build and run AI systems that{' '}
            <strong className="text-white" data-id="element-503">
              generate pipeline, serve customers, automate processes, and reduce
              costs
            </strong>{' '}
            — with pricing tied to outcomes, not hours.{' '}
            <strong className="text-white" data-id="element-504">
              70% of mid-market companies need outside help implementing AI.
            </strong>{' '}
            We close that gap.
          </p>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-6 md:px-10 py-3" data-id="element-505">
        <div className="flex flex-col md:flex-row gap-6" data-id="element-506">
          {/* Left Column - Services */}
          <div className="md:w-2/3" data-id="element-507">
            <h2 className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2 border-b border-slate-200 pb-1" data-id="element-508">
              Core AI Service Lines
            </h2>

            <div className="space-y-1.5 mb-3" data-id="element-509">
              {/* AI Customer Support Automation */}
              <div className="bg-white rounded-lg border border-slate-200 border-l-4 border-l-emerald-500 shadow-sm overflow-hidden" data-id="element-510">
                <div className="flex flex-col sm:flex-row" data-id="element-511">
                  <div className="sm:w-24 shrink-0 flex flex-col items-center justify-center p-2 bg-emerald-50/60 border-b sm:border-b-0 sm:border-r border-emerald-100" data-id="element-512">
                    <span className="text-xl font-extrabold text-emerald-600 leading-none tracking-tight" data-id="element-513">
                      60–80%
                    </span>
                    <span className="text-[8px] font-semibold text-emerald-600/70 uppercase tracking-wider mt-0.5" data-id="element-514">
                      Cost Reduction
                    </span>
                  </div>
                  <div className="p-2 flex-1" data-id="element-515">
                    <h3 className="font-bold text-slate-900 mb-1 text-xs" data-id="element-516">
                      AI Customer Support Automation
                    </h3>
                    <div className="grid sm:grid-cols-2 gap-x-3 gap-y-0.5" data-id="element-517">
                      <div className="flex items-start gap-1 text-[11px] text-slate-700" data-id="element-518">
                        <span className="text-emerald-500 mt-0.5 shrink-0" data-id="element-519">
                          ▸
                        </span>
                        <span data-id="element-520">
                          24/7 coverage — no nights, weekends, or PTO gaps
                        </span>
                      </div>
                      <div className="flex items-start gap-1 text-[11px] text-slate-700" data-id="element-521">
                        <span className="text-emerald-500 mt-0.5 shrink-0" data-id="element-522">
                          ▸
                        </span>
                        <span data-id="element-523">Faster resolution and higher CSAT scores</span>
                      </div>
                      <div className="flex items-start gap-1 text-[11px] text-slate-700" data-id="element-524">
                        <span className="text-emerald-500 mt-0.5 shrink-0" data-id="element-525">
                          ▸
                        </span>
                        <span data-id="element-526">
                          Team freed for complex, high-value interactions
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* AI Sales & Outbound Automation */}
              <div className="bg-white rounded-lg border border-slate-200 border-l-4 border-l-blue-500 shadow-sm overflow-hidden" data-id="element-527">
                <div className="flex flex-col sm:flex-row" data-id="element-528">
                  <div className="sm:w-24 shrink-0 flex flex-col items-center justify-center p-2 bg-blue-50/60 border-b sm:border-b-0 sm:border-r border-blue-100" data-id="element-529">
                    <span className="text-xl font-extrabold text-blue-600 leading-none tracking-tight" data-id="element-530">
                      2–3×
                    </span>
                    <span className="text-[8px] font-semibold text-blue-600/70 uppercase tracking-wider mt-0.5" data-id="element-531">
                      Pipeline Growth
                    </span>
                  </div>
                  <div className="p-2 flex-1" data-id="element-532">
                    <h3 className="font-bold text-slate-900 mb-1 text-xs" data-id="element-533">
                      AI Sales & Outbound Automation
                    </h3>
                    <div className="grid sm:grid-cols-2 gap-x-3 gap-y-0.5" data-id="element-534">
                      <div className="flex items-start gap-1 text-[11px] text-slate-700" data-id="element-535">
                        <span className="text-blue-500 mt-0.5 shrink-0" data-id="element-536">▸</span>
                        <span data-id="element-537">
                          Every prospect gets a tailored, timely touch
                        </span>
                      </div>
                      <div className="flex items-start gap-1 text-[11px] text-slate-700" data-id="element-538">
                        <span className="text-blue-500 mt-0.5 shrink-0" data-id="element-539">▸</span>
                        <span data-id="element-540">Higher meeting-to-close conversion rates</span>
                      </div>
                      <div className="flex items-start gap-1 text-[11px] text-slate-700" data-id="element-541">
                        <span className="text-blue-500 mt-0.5 shrink-0" data-id="element-542">▸</span>
                        <span data-id="element-543">
                          AI-scored leads for predictable revenue forecasting
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* AI Marketing & Content Automation */}
              <div className="bg-white rounded-lg border border-slate-200 border-l-4 border-l-violet-500 shadow-sm overflow-hidden" data-id="element-544">
                <div className="flex flex-col sm:flex-row" data-id="element-545">
                  <div className="sm:w-24 shrink-0 flex flex-col items-center justify-center p-2 bg-violet-50/60 border-b sm:border-b-0 sm:border-r border-violet-100" data-id="element-546">
                    <span className="text-xl font-extrabold text-violet-600 leading-none tracking-tight" data-id="element-547">
                      3–5×
                    </span>
                    <span className="text-[8px] font-semibold text-violet-600/70 uppercase tracking-wider mt-0.5" data-id="element-548">
                      Content Output
                    </span>
                  </div>
                  <div className="p-2 flex-1" data-id="element-549">
                    <h3 className="font-bold text-slate-900 mb-1 text-xs" data-id="element-550">
                      AI Marketing & Content Automation
                    </h3>
                    <div className="grid sm:grid-cols-2 gap-x-3 gap-y-0.5" data-id="element-551">
                      <div className="flex items-start gap-1 text-[11px] text-slate-700" data-id="element-552">
                        <span className="text-violet-500 mt-0.5 shrink-0" data-id="element-553">
                          ▸
                        </span>
                        <span data-id="element-554">
                          Lower cost per lead through automated optimization
                        </span>
                      </div>
                      <div className="flex items-start gap-1 text-[11px] text-slate-700" data-id="element-555">
                        <span className="text-violet-500 mt-0.5 shrink-0" data-id="element-556">
                          ▸
                        </span>
                        <span data-id="element-557">Personalized customer journeys on autopilot</span>
                      </div>
                      <div className="flex items-start gap-1 text-[11px] text-slate-700" data-id="element-558">
                        <span className="text-violet-500 mt-0.5 shrink-0" data-id="element-559">
                          ▸
                        </span>
                        <span data-id="element-560">
                          Faster launches with less manual coordination
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Agentic AI & Workflow Automation */}
              <div className="bg-white rounded-lg border border-slate-200 border-l-4 border-l-amber-500 shadow-sm overflow-hidden" data-id="element-561">
                <div className="flex flex-col sm:flex-row" data-id="element-562">
                  <div className="sm:w-24 shrink-0 flex flex-col items-center justify-center p-2 bg-amber-50/60 border-b sm:border-b-0 sm:border-r border-amber-100" data-id="element-563">
                    <span className="text-xl font-extrabold text-amber-600 leading-none tracking-tight" data-id="element-564">
                      2.5+
                    </span>
                    <span className="text-[8px] font-semibold text-amber-600/70 uppercase tracking-wider mt-0.5" data-id="element-565">
                      Hrs/Day Saved
                    </span>
                  </div>
                  <div className="p-2 flex-1" data-id="element-566">
                    <h3 className="font-bold text-slate-900 mb-1 text-xs" data-id="element-567">
                      Agentic AI & Workflow Automation
                      <span className="text-[8px] font-bold tracking-wider text-blue-600 bg-blue-50 px-1 py-0.5 rounded uppercase ml-2" data-id="element-568">
                        Premium
                      </span>
                    </h3>
                    <div className="grid sm:grid-cols-2 gap-x-3 gap-y-0.5" data-id="element-569">
                      <div className="flex items-start gap-1 text-[11px] text-slate-700" data-id="element-570">
                        <span className="text-amber-500 mt-0.5 shrink-0" data-id="element-571">
                          ▸
                        </span>
                        <span data-id="element-572">
                          End-to-end process execution — no handoffs or gaps
                        </span>
                      </div>
                      <div className="flex items-start gap-1 text-[11px] text-slate-700" data-id="element-573">
                        <span className="text-amber-500 mt-0.5 shrink-0" data-id="element-574">
                          ▸
                        </span>
                        <span data-id="element-575">Reduced errors and faster cycle times</span>
                      </div>
                      <div className="flex items-start gap-1 text-[11px] text-slate-700" data-id="element-576">
                        <span className="text-amber-500 mt-0.5 shrink-0" data-id="element-577">
                          ▸
                        </span>
                        <span data-id="element-578">Measurable cost savings tied to AI output</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* How You're Charged Section */}
            <div className="bg-[#0f2546] rounded-xl p-3 text-white shadow-lg" data-id="element-579">
              <h2 className="text-[10px] font-bold text-blue-300 uppercase tracking-widest mb-2 border-b border-slate-700 pb-1" data-id="element-580">
                How You're Charged — And Why It's Different
              </h2>
              <div className="grid md:grid-cols-3 gap-2" data-id="element-581">
                <div className="bg-[#1a365d] p-2 rounded-lg border border-slate-700" data-id="element-582">
                  <h4 className="text-[9px] font-bold text-slate-400 uppercase tracking-wider mb-0.5" data-id="element-583">
                    Setup Fee
                  </h4>
                  <p className="text-[11px] text-slate-200" data-id="element-584">
                    One-time build & integration — split across{' '}
                    <span className="text-blue-300" data-id="element-585">two milestones</span>
                  </p>
                </div>
                <div className="bg-[#1a365d] p-2 rounded-lg border border-slate-700" data-id="element-586">
                  <h4 className="text-[9px] font-bold text-slate-400 uppercase tracking-wider mb-0.5" data-id="element-587">
                    Monthly Retainer
                  </h4>
                  <p className="text-[11px] text-slate-200" data-id="element-588">
                    Ongoing management, optimization & support —{' '}
                    <span className="text-blue-300" data-id="element-589">keeps improving</span>
                  </p>
                </div>
                <div className="bg-[#1a365d] p-2 rounded-lg border border-slate-700" data-id="element-590">
                  <h4 className="text-[9px] font-bold text-slate-400 uppercase tracking-wider mb-0.5" data-id="element-591">
                    Performance Fee
                  </h4>
                  <p className="text-[11px] text-slate-200" data-id="element-592">
                    Triggered only on{' '}
                    <span className="text-blue-300" data-id="element-593">verified results</span> —
                    meetings, tickets, leads
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Sidebar */}
          <div className="md:w-1/3 space-y-5" data-id="element-594">
            {/* Market Context */}
            <div data-id="element-595">
              <h2 className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2 border-b border-slate-200 pb-1.5" data-id="element-596">
                Market Context
              </h2>
              <div className="grid grid-cols-3 gap-2" data-id="element-597">
                <div className="bg-[#0f2546] text-white p-3 rounded-lg text-center flex flex-col justify-center" data-id="element-598">
                  <span className="text-xl font-bold mb-0.5" data-id="element-599">70%</span>
                  <span className="text-[9px] text-slate-300 leading-tight" data-id="element-600">
                    of mid-market firms need outside help with AI (RSM 2025)
                  </span>
                </div>
                <div className="bg-[#0f2546] text-white p-3 rounded-lg text-center flex flex-col justify-center" data-id="element-601">
                  <span className="text-xl font-bold mb-0.5" data-id="element-602">91%</span>
                  <span className="text-[9px] text-slate-300 leading-tight" data-id="element-603">
                    adopted gen AI — only 29% have scaled it successfully
                  </span>
                </div>
                <div className="bg-[#0f2546] text-white p-3 rounded-lg text-center flex flex-col justify-center" data-id="element-604">
                  <span className="text-xl font-bold mb-0.5" data-id="element-605">$91B</span>
                  <span className="text-[9px] text-slate-300 leading-tight" data-id="element-606">
                    AI consulting market by 2035 at 26% CAGR
                  </span>
                </div>
              </div>
            </div>

            {/* Ideal Client Profile */}
            <div data-id="element-607">
              <h2 className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2 border-b border-slate-200 pb-1.5" data-id="element-608">
                Ideal Client Profile
              </h2>
              <ul className="space-y-1.5 text-xs text-slate-700" data-id="element-609">
                <li className="flex items-start" data-id="element-610">
                  <span className="text-blue-500 mr-1.5 mt-0.5" data-id="element-611">•</span>
                  $10M–$100M revenue · 15–250 employees
                </li>
                <li className="flex items-start" data-id="element-612">
                  <span className="text-blue-500 mr-1.5 mt-0.5" data-id="element-613">•</span>
                  Professional services, financial services, SaaS,
                  healthcare-adjacent, real estate
                </li>
                <li className="flex items-start" data-id="element-614">
                  <span className="text-blue-500 mr-1.5 mt-0.5" data-id="element-615">•</span>
                  Has AI tools but can't scale, integrate, or measure ROI
                </li>
                <li className="flex items-start" data-id="element-616">
                  <span className="text-blue-500 mr-1.5 mt-0.5" data-id="element-617">•</span>
                  Thin teams, manual processes, flat pipeline, or missed revenue
                  signals
                </li>
              </ul>
            </div>

            {/* Why Swedenmark AI */}
            <div data-id="element-618">
              <h2 className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2 border-b border-slate-200 pb-1.5" data-id="element-619">
                Why Swedenmark AI
              </h2>
              <ul className="space-y-2 text-xs text-slate-700" data-id="element-620">
                <li className="flex items-start" data-id="element-621">
                  <div className="bg-[#0f2546] text-white rounded w-4 h-4 flex items-center justify-center mr-2 mt-0.5 shrink-0 text-[9px] font-bold" data-id="element-622">
                    +
                  </div>
                  <p data-id="element-623">
                    <strong className="text-slate-900" data-id="element-624">
                      Performance-tied pricing.
                    </strong>{' '}
                    Only 10–15% of AI consultancies offer outcome-based fees —
                    we do on every engagement.
                  </p>
                </li>
                <li className="flex items-start" data-id="element-625">
                  <div className="bg-[#0f2546] text-white rounded w-4 h-4 flex items-center justify-center mr-2 mt-0.5 shrink-0 text-[9px] font-bold" data-id="element-626">
                    ◫
                  </div>
                  <p data-id="element-627">
                    <strong className="text-slate-900" data-id="element-628">
                      Boutique quality, no agency overhead.
                    </strong>{' '}
                    Results at 40–60% of what large firms charge.
                  </p>
                </li>
                <li className="flex items-start" data-id="element-629">
                  <div className="bg-[#0f2546] text-white rounded w-4 h-4 flex items-center justify-center mr-2 mt-0.5 shrink-0 text-[9px] font-bold" data-id="element-630">
                    ▤
                  </div>
                  <p data-id="element-631">
                    <strong className="text-slate-900" data-id="element-632">
                      We build and run the system.
                    </strong>{' '}
                    Full deployment, integration, and ongoing management.
                  </p>
                </li>
                <li className="flex items-start" data-id="element-633">
                  <div className="bg-[#0f2546] text-white rounded w-4 h-4 flex items-center justify-center mr-2 mt-0.5 shrink-0 text-[9px] font-bold" data-id="element-634">
                    ◎
                  </div>
                  <p data-id="element-635">
                    <strong className="text-slate-900" data-id="element-636">
                      Live attribution from Day 1.
                    </strong>{' '}
                    Dashboards show exactly what the system produces in real
                    time.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>

      {/* Footer Section */}
      <footer className="bg-[#0f2546] text-white py-3 px-6 md:px-10 mt-3" data-id="element-637">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-638">
          <div className="md:w-1/2" data-id="element-639">
            <h3 className="text-sm font-bold mb-0.5" data-id="element-640">
              Let's find your highest-ROI AI use case.
            </h3>
            <p className="text-xs text-slate-400" data-id="element-641">
              Book a 30-minute strategy call — workflow audit and clear
              recommendation, no pitch.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-6 text-xs text-slate-400" data-id="element-642">
            <div data-id="element-643">
              <p className="uppercase text-[9px] tracking-widest mb-0.5" data-id="element-644">
                Model
              </p>
              <p className="text-blue-300" data-id="element-645">Retainer + Performance</p>
            </div>
            <div data-id="element-646">
              <p className="uppercase text-[9px] tracking-widest mb-0.5" data-id="element-647">
                Market
              </p>
              <p className="text-blue-300" data-id="element-648">$10M–$100M Rev.</p>
            </div>
            <div className="text-right sm:text-left" data-id="element-649">
              <p className="font-bold text-white mb-0.5" data-id="element-650">swedenmark.ai</p>
              <p data-id="element-651">hello@swedenmark.ai</p>
              <p data-id="element-652">Pompano Beach, FL</p>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}